module.exports = __webpack_public_path__ + "static/media/свобода-движения.1eb6d688.jpg";